{
  "title": "Dév",
  "UI": {
    "title": "Interface utilisateur"
  },
  "createDeviceActionSchedule": {
    "title": "Créer un calendrier d'action pour l'appareil"
  },
  "schedulesView": {
    "title": "Horaires"
  },
  "alertsDemo": {
    "alerts": "Alertes",
    "linkTo": "Démo des alertes",
    "showTitleCheckbox": "Titre",
    "title": "Démo des alertes"
  },
  "buttonsDemo": {
    "actionButtons": "Boutons d'action {{direction}}",
    "title": "Boutons de démonstration"
  },
  "devLanding": {
    "linkTo": "atterrissage-dev",
    "title": "Atterrissage du développeur"
  },
  "fontDemo": {
    "italic": "Italique",
    "linkTo": "police-demo",
    "regular": "Régulier",
    "subheader": "Titre secondaire",
    "title": "Démonstration de police"
  },
  "linkTo": "Dév",
  "scratch": {
    "linkTo": "gratter",
    "title": "Gratter"
  }
}
